import CombinedMenus from './CombinedMenus'

export default CombinedMenus
